const getParcelTrackingNumberStyles = theme => ({
  textAlign: 'left',
  [theme.mediaQuery('tablet')]: {
    textAlign: 'right'
  }
});
const getTrackingNumberAsideStyles = theme => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  flexDirection: 'column',
  [theme.mediaQuery('tablet')]: {
    paddingRight: theme.spacing(5),
    alignItems: 'flex-end'
  }
});

export { getParcelTrackingNumberStyles, getTrackingNumberAsideStyles };
//# sourceMappingURL=TrackingNumberAsideStyles.js.map
